import L from 'leaflet';

import {map, GetUserName, GetUserId} from './Main.js'
import {GetHtmlObject} from './PoleManager.js'
import {findPolylineById} from './lines.js'
import {GetIndexMovingPParray} from './PPManager.js'

import imageSrcPP from '../images/ps.svg';
import imageSrcPPZero from '../images/pp_0.png';
import imageSrcTP from '../images/tp.svg';
import imageSrcRP from '../images/rp.svg';
import imageSrcRecloser from '../images/rk.svg';
import imageSrcSergek from '../images/sergek.png';
import imageSrcBanner from '../images/banner.png';

var mainMarkersArray = [];
var poleMarkersArray = [];

var lastInsertedMarker = null;

var latLngForDistance;

// Объявляем переменную для хранения подсказки
var tooltipDistance = null;

const standardIconSize = 22;

export function GetLastInsertedMarker() {
  return lastInsertedMarker;
}

export function SetLastInsertedMarker(marker) {
  lastInsertedMarker = marker;
}

export function ClearMainMarkersArray() {
  mainMarkersArray.forEach(marker => {
    map.removeLayer(marker);
  });
  mainMarkersArray = []; // Очищаем массив маркеров
}

export function ClearPoleMarkersArray() {
  poleMarkersArray.forEach(marker => {
    map.removeLayer(marker);
  });
  poleMarkersArray = []; // Очищаем массив маркеров
}

export function DrawMainMarker(latLng, objectNumber, typecode, textPosition, iMarker, id, linkedtp, has_children) {
  var currentZoom = map.getZoom();
  var iconSize = standardIconSize;
  if (currentZoom < standardIconSize) {
    iconSize -= -2 + (standardIconSize - currentZoom);
  }
  var iconUrl;
  switch (typecode) {
    case 11:
      iconUrl = imageSrcTP;//"./../images/tp.png";
      break;
    case 13:
      /*if (has_children == 0) {
        iconUrl = imageSrcPPZero;
      }
      else {
        iconUrl = imageSrcPP;//"./../images/pp.png";
      }*/
     iconUrl = imageSrcPP;
      break;
    case 24:
      iconUrl = imageSrcRP;//"./../images/tp.png";
      break;
    case 25:
      iconUrl = imageSrcRecloser;//"./../images/tp.png";
      break;
  }
  var icon = L.icon({
    //html: '<span class="text-left">' + 123 + '</span>',
    iconUrl: iconUrl,
    iconSize: [iconSize, iconSize]
  });
  if (iMarker === null) {
    var marker = L.marker(latLng, {
      icon: icon,
      draggable: GetIndexMovingPParray(linkedtp) > -1,//document.getElementById('IsMovingObj').checked,
      id: id,
      name: objectNumber,
      typecode: typecode,
      linkedtp: linkedtp,
      _iconUrl: iconUrl  
    });
  } else {
    map.removeLayer(iMarker);
    var marker = L.marker(latLng, {
      icon: icon,
      draggable: GetIndexMovingPParray(linkedtp) > -1,//document.getElementById('IsMovingObj').checked,
      id: id,
      name: objectNumber,
      typecode: typecode,
      linkedtp: linkedtp,
      _iconUrl: iconUrl  
    });
  }

  if (typecode == 13) {
    marker.setZIndexOffset(1000);
  }

  var offsetPosition;
  switch (textPosition) {
    case 0:
      offsetPosition = [0, -20];
      break;
    case 1:
      offsetPosition = [20 + objectNumber.length * 3, 0];
      break;
    case 2:
      offsetPosition = [0, 20];
      break;
    case 3:
      offsetPosition = [-20 - objectNumber.length * 3, 0];
      break;
  }
  marker.bindTooltip(objectNumber, {
    permanent: true,
    offset: offsetPosition,
    direction: 'center',
    className: "my-labels"
  });
  /*map.on('zoomend', function () {
    var currentZoom = map.getZoom();
    iconSize = standardIconSize;

    if (currentZoom < standardIconSize) {
      iconSize -= -2 + (standardIconSize - currentZoom);
    }
    var icon = L.icon({
      // html: '<span class="text-left">' + 123 + '</span>',
      iconUrl: iconUrl,
      iconSize: [iconSize, iconSize]
    });
    marker.setIcon(icon);
  });*/
  console.log('mainMarkersArray length:', mainMarkersArray.length);
console.log('marker in array:', mainMarkersArray.includes(marker));
  if (!mainMarkersArray.includes(marker)) {
    marker.on('contextmenu', function (e) {
      //e.preventDefault(); // Предотвращаем стандартное контекстное меню
      // Ваш код обработки события contextmenu (если необходимо)
    });
    MarkerSetup(marker, id);
    mainMarkersArray.push(marker);
    //lastInsertedMarker = marker;
    return marker;
  }
  else {
    console.log("uzhe ext");
    return null;
  }
}

export function  DrawPoleMarker(latLng, poleType, quantityPlafond, objectNumber, radius, borderWidth, textPosition, iMarker, id, linkedtp) {
  var currentZoom = map.getZoom();
  var size = radius * 2 * (currentZoom / 2);
  var size = radius /** 2*/ * currentZoom /*/ 2*/;
  //var size = radius - (radius * (1 - currentZoom / radius));

  var fontSize = 12;
  switch (currentZoom) {
    case 18:
      fontSize = 12;
      break;
    case 17:
      fontSize = 9;
      break;
    case 16:
      fontSize = 6;
      break;
    case 15:
      fontSize = 3;
      break;
    default:
      fontSize = 0;
      break;
  }
  if (currentZoom < standardIconSize) {
    size -= 2 + (standardIconSize - currentZoom);
  }
  if (poleType == '4') {
    size -= 4;
    fontSize -= 2;
  }
  if (poleType == '3') {
    size -= 2;
    fontSize -= 2;
  }
  if (fontSize < 0) {
    fontSize = 0;
  }
  var style = 'style="width: ' + size + 'px; height: ' + size + 'px; border-width: ' + borderWidth + 'px; font-size: ' + fontSize + 'px;"';
  var styleNoBorder = 'style="width: ' + size + 'px; height: ' + size + 'px; font-size: ' + fontSize + 'px; border: none;"';
  var iconSize = size + borderWidth * 2;
  var htmlObject;
  htmlObject = GetHtmlObject(poleType, style, styleNoBorder, quantityPlafond, objectNumber, textPosition);
  var icon = L.divIcon({
    html: htmlObject,
    //'<span class="' + 'circle ' + circleClass + '" ' + style + '>' + quantityPlafond + '</span><span class="text-left">' + objectNumber + '</span>',
    className: '',
    iconSize: [iconSize, iconSize]
  });
  if (iMarker === null) {
    var marker = L.marker(latLng, {
      icon: icon,
      draggable: GetIndexMovingPParray(linkedtp) > -1,//document.getElementById('IsMovingObj').checked,
      id: id,
      name: objectNumber,
      typecode: poleType,
      linkedtp: linkedtp,
      _poleType: poleType,              // ← добавить
      _quantityPlafond: quantityPlafond, // ← добавить
      _textPosition: textPosition,       // ← добавить
      _borderWidth: borderWidth,         // ← добавить
      _radius: radius 
    });
  } else {
    var foundMarker = poleMarkersArray.find(function(markerObject) {
      return markerObject.options.id == id;
    });
    // Если маркер не найден в массиве (например, уже был убран другим кодом) —
    // используем координаты, переданные в функцию, вместо падения на .getLatLng()
    // у undefined.
    const markerLatlng = foundMarker ? foundMarker.getLatLng() : latLng;
    if (foundMarker) {
      map.removeLayer(foundMarker);
      var index = poleMarkersArray.indexOf(foundMarker);
      // Проверяем, найден ли маркер в массиве
      if (index !== -1) {
          // Удаляем маркер по индексу
          poleMarkersArray.splice(index, 1);
      } else {
       //   console.log("Маркер не найден в массиве");
      }
    }
    var marker = L.marker(markerLatlng, {
      icon: icon,
      draggable: GetIndexMovingPParray(linkedtp) > -1,//document.getElementById('IsMovingObj').checked,
      id: id,
      name: objectNumber,
      typecode: poleType,
      linkedtp: linkedtp,
      _poleType: poleType,              // ← добавить
      _quantityPlafond: quantityPlafond, // ← добавить
      _textPosition: textPosition,       // ← добавить
      _borderWidth: borderWidth,         // ← добавить
      _radius: radius
    });
  }
/*  map.on('zoomend', function () {
    var currentZoom = map.getZoom();
    var size = radius  * currentZoom;

    var fontSize = 12;
    switch (currentZoom) {
      case 18:
        fontSize = 12;
        break;
      case 17:
        fontSize = 9;
        break;
      case 16:
        fontSize = 6;
        break;
      case 15:
        fontSize = 3;
        break;
      default:
        fontSize = 0;
        break;
    }
    if (currentZoom < standardIconSize) {
      size -= 2 + (standardIconSize - currentZoom);
    }
    if (poleType == '4') {
      size -= 4;
      fontSize -= 2;
    }
    
    if (poleType == '3') {
      console.log("zoom test " + size);
      size -= 8;
      console.log("zoom test " + size);
      //fontSize -= 2;
    }
    var style = 'style="width: ' + size + 'px; height: ' + size + 'px; border-width: ' + borderWidth + 'px; font-size: ' + fontSize + 'px;"';
    htmlObject = GetHtmlObject(poleType, style, quantityPlafond, objectNumber, textPosition);
    var iconSize = size + borderWidth * 2;

    var icon = L.divIcon({
      html: htmlObject,
      className: '',
      iconSize: [iconSize, iconSize]
    });
    marker.setIcon(icon);
  });*/
  marker.on('contextmenu', function (e) {
   // e.preventDefault(); // Предотвращаем стандартное контекстное меню
    // Ваш код обработки события contextmenu (если необходимо)
  });
  MarkerSetup(marker, id);
  poleMarkersArray.push(marker);
  //lastInsertedMarker = marker;
  return marker;
}

export function DrawDecorativeMarker(latLng, typecode, id, linkedtp, iMarker) {
    var iconUrl;
    switch (typecode) {
      case 10:
        iconUrl = imageSrcSergek;
        break;
      case 12:
        iconUrl = imageSrcBanner;
        break;
    }
    var currentZoom = map.getZoom();
    var iconSize = standardIconSize;
    if (currentZoom < standardIconSize) {
      iconSize -= 2 + (standardIconSize - currentZoom);
    }
    var icon = L.icon({
      iconUrl: iconUrl,
      iconSize: [iconSize, iconSize]
    });
    
    if (iMarker === null) {
      var marker = L.marker(latLng, {
        icon: icon,
        draggable: GetIndexMovingPParray(linkedtp) > -1,//document.getElementById('IsMovingObj').checked,
        id: id,
        name: '',
        typecode: typecode,
        linkedtp: linkedtp,
        _iconUrl: iconUrl 
      });
    } else {
      var foundMarker = poleMarkersArray.find(function(markerObject) {
        return markerObject.options.id === id;
      });
      // Если маркер не найден в массиве — используем переданные координаты
      // вместо падения на .getLatLng() у undefined.
      const markerLatlng = foundMarker ? foundMarker.getLatLng() : latLng;
      if (foundMarker) {
        map.removeLayer(foundMarker);
        var index = poleMarkersArray.indexOf(foundMarker);
        // Проверяем, найден ли маркер в массиве
        if (index !== -1) {
            // Удаляем маркер по индексу
            poleMarkersArray.splice(index, 1);
        } else {
          //  console.log("Маркер не найден в массиве");
        }
      }
      var marker = L.marker(markerLatlng, {
        icon: icon,
        draggable: GetIndexMovingPParray(linkedtp) > -1,//document.getElementById('IsMovingObj').checked,
        id: id,
        name: '',
        typecode: typecode,
        linkedtp: linkedtp,
        _iconUrl: iconUrl
      });
    }
    /*map.on('zoomend', function () {
      var currentZoom = map.getZoom();
      iconSize = standardIconSize;
      if (currentZoom < standardIconSize) {
        iconSize -= 2 + (standardIconSize - currentZoom);
      }
      var icon = L.icon({
        iconUrl: iconUrl,
        iconSize: [iconSize, iconSize]
      });
      marker.setIcon(icon);
    });*/
    marker.on('contextmenu', function (e) {
     // e.preventDefault(); // Предотвращаем стандартное контекстное меню
      // Ваш код обработки события contextmenu (если необходимо)
    });
    MarkerSetup(marker, id);
    //mainMarkersArray.push(marker);
    poleMarkersArray.push(marker);
    return marker;
  }

  function MarkerSetup(marker, id) {
    var savedTooltip = null; 
    marker.on("dragstart", function (e) {
      latLngForDistance = null;
      savedTooltip = marker.getTooltip();
      marker.unbindTooltip();
      fetch(`${process.env.REACT_APP_BASE_URL}/api/lines_list/get_from_id_object/${id}`)
      .then(response => response.json())
      .then(data => {
        data.forEach(object => {
         
         latLngForDistance = L.latLng(object.start_lat, object.start_lng);
        });
      });
    });

    marker.on("drag", function (e) {
      var marker = e.target;
      var position = marker.getLatLng();

      if (latLngForDistance != null) {
        var distance = position.distanceTo(latLngForDistance); // Измерение расстояния между точками

        var tooltipContent = `Длина входящей линии: ${distance.toFixed(2)} м`;
        if (tooltipDistance) {
          tooltipDistance.setContent(tooltipContent); // Обновляем содержимое существующей подсказки
      } else {
        tooltipDistance = L.tooltip({
              permanent: true,
              direction: 'auto'
          }).setContent(tooltipContent);
          marker.bindTooltip(tooltipDistance).openTooltip(); // Создаем новую подсказку, если она не существует
      }
      }
      
    });

    marker.on("dragend", function (e) {
      var marker = e.target;
      //if (marker.getTooltip()) {
       // marker.unbindTooltip();
     // }
      var position = marker.getLatLng();

      if (lastInsertedMarker) {
        if (lastInsertedMarker.options.id === marker.options.id) {
          lastInsertedMarker = marker;
        }
      }

      // Посылание информации на сервер методом POST
      //fetch(`${process.env.REACT_APP_BASE_URL}/upd_object_position`, {
      fetch(`${process.env.REACT_APP_BASE_URL}/api/objects_list/upd_object_position`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          lat: position.lat,
          lng: position.lng,
          id: id,
          userId: GetUserId(),      // ← добавить
          username: GetUserName()
        })
      }).then((response) => {
        if (!response.ok) {
          return response.json().then((errData) => {
            throw new Error(errData.error || `Ошибка сервера: ${response.status}`);
          });
        }
      }).catch(error => {
        console.error('Ошибка обновления позиции ', error);
        alert(`Не удалось сохранить новую позицию объекта: ${error.message}`);
      });
      //fetch(`${process.env.REACT_APP_BASE_URL}/upd_lines_by_from_id/${id}/${position.lat}/${position.lng}`).then(response => response.json()).then(lines => {
      //fetch(`${process.env.REACT_APP_BASE_URL}/api/lines_list/upd_lines_by_from_id/${id}/${position.lat}/${position.lng}`).then(response => response.json()).then(lines => {
     fetch(`${process.env.REACT_APP_BASE_URL}/api/lines_list/upd_lines_by_from_id`, {
      method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          lat: position.lat,
          lng: position.lng,
          id: id
        })
     }).then((response) => {
        if (!response.ok) {
          return response.json().then((errData) => {
            throw new Error(errData.error || `Ошибка сервера: ${response.status}`);
          });
        }
        return response.json();
     }).then(lines => {
        // Взаимодействие со всеми имеющимися линиями
        lines.forEach(line => {
          const {
            id,
            from_id,
            to_id,
            linkedtp,
            start_lat,
            start_lng,
            end_lat,
            end_lng,
            typecode
          } = line;
          var idToFind = line.id;
          var foundPolyline = findPolylineById(idToFind);
          if (foundPolyline) {
            var latlngs = foundPolyline.getLatLngs();
            
            // Обновляем только первую точку (начало линии), 
            // сохраняя все промежуточные точки кривой как есть
            var newLatLngs = [...latlngs];
            newLatLngs[0] = L.latLng(position.lat, position.lng);
            
            foundPolyline.setLatLngs(newLatLngs);
            foundPolyline.redraw();
          } else {
           // console.log('Полилиния с id', idToFind, 'не найдена');
          }
        });
      }).catch(error => {
        console.error('Ошибка обновления линий (from_id):', error);
        alert(`Не удалось обновить связанные линии: ${error.message}`);
      });
      //fetch(`${process.env.REACT_APP_BASE_URL}/upd_lines_by_to_id/${id}/${position.lat}/${position.lng}`).then(response => response.json()).then(lines => {
      //fetch(`${process.env.REACT_APP_BASE_URL}/api/lines_list/upd_lines_by_to_id/${id}/${position.lat}/${position.lng}`).then(response => response.json()).then(lines => {
      fetch(`${process.env.REACT_APP_BASE_URL}/api/lines_list/upd_lines_by_to_id`, {
          method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              lat: position.lat,
              lng: position.lng,
              id: id
            })
         }).then((response) => {
            if (!response.ok) {
              return response.json().then((errData) => {
                throw new Error(errData.error || `Ошибка сервера: ${response.status}`);
              });
            }
            return response.json();
         }).then(lines => {
        // Взаимодействие со всеми имеющимися линиями
        lines.forEach(line => {
          const {
            id,
            from_id,
            to_id,
            linkedtp,
            start_lat,
            start_lng,
            end_lat,
            end_lng,
            typecode
          } = line;
          var idToFind = line.id;
          var foundPolyline = findPolylineById(idToFind);
          if (foundPolyline) {
            var latlngs = foundPolyline.getLatLngs();
            
            var newLatLngs = [...latlngs];
            newLatLngs[newLatLngs.length - 1] = L.latLng(position.lat, position.lng);
            
            foundPolyline.setLatLngs(newLatLngs);
            foundPolyline.redraw();
          } else {
          //  console.log('Полилиния с id', idToFind, 'не найдена');
          }
        });
      }).catch(error => {
        console.error('Ошибка обновления линий (to_id):', error);
        alert(`Не удалось обновить связанные линии: ${error.message}`);
      });

      if (tooltipDistance) {
        marker.unbindTooltip(); // Снимаем всплывающую подсказку после завершения перемещения, если она существует
        tooltipDistance = null; // Обнуляем переменную, чтобы создать новую подсказку при следующем перемещении
      }
      if (savedTooltip) {
        marker.bindTooltip(savedTooltip);
        savedTooltip = null;
      }
    });
    
  }

  export function SetDraggable(isOn, linkedtp) {
    if (isOn) {
      mainMarkersArray.forEach(marker => {
        if (marker.dragging !== undefined && marker.options.linkedtp === linkedtp) marker.dragging.enable();
      });
      poleMarkersArray.forEach(marker => {
        if (marker.dragging !== undefined && marker.options.linkedtp === linkedtp) marker.dragging.enable();
      });
    } else {
      mainMarkersArray.forEach(marker => {
        if (marker.dragging !== undefined && marker.options.linkedtp === linkedtp) marker.dragging.disable();
      });
      poleMarkersArray.forEach(marker => {
        if (marker.dragging !== undefined && marker.options.linkedtp === linkedtp) marker.dragging.disable();
      });
    }
  }

  let zoomHandlerReady = false;

export function SetupZoomHandler() {
  if (zoomHandlerReady) return;
  zoomHandlerReady = true;

  map.on('zoomend', function () {
    const currentZoom = map.getZoom();

    // Главные маркеры и декоративные
    [...mainMarkersArray, ...poleMarkersArray].forEach(marker => {
      if (marker.options._iconUrl) {
        let iconSize = standardIconSize;
        if (currentZoom < standardIconSize) {
          iconSize -= -2 + (standardIconSize - currentZoom);
        }
        marker.setIcon(L.icon({ iconUrl: marker.options._iconUrl, iconSize: [iconSize, iconSize] }));
      } else if (marker.options._poleType) {
        const { _poleType, _quantityPlafond, _textPosition, _borderWidth, _radius } = marker.options;
        let size = _radius * currentZoom;
        let fontSize = 12;
        switch (currentZoom) {
          case 18: fontSize = 12; break;
          case 17: fontSize = 9; break;
          case 16: fontSize = 6; break;
          case 15: fontSize = 3; break;
          default: fontSize = 0; break;
        }
        if (currentZoom < standardIconSize) size -= 2 + (standardIconSize - currentZoom);
        if (_poleType == '4') { size -= 4; fontSize -= 2; }
        if (_poleType == '3') { size -= 8; }
        if (fontSize < 0) fontSize = 0;
        const style = `style="width: ${size}px; height: ${size}px; border-width: ${_borderWidth}px; font-size: ${fontSize}px;"`;
        const styleNoBorder = 'style="width: ' + size + 'px; height: ' + size + 'px; font-size: ' + fontSize + 'px; border: none;"';
        const htmlObject = GetHtmlObject(_poleType, style, styleNoBorder, _quantityPlafond, marker.options.name, _textPosition);
        marker.setIcon(L.divIcon({ html: htmlObject, className: '', iconSize: [size + _borderWidth * 2, size + _borderWidth * 2] }));
      }
    });
  });
}